import { render, staticRenderFns } from "./TableConsultPrice.vue?vue&type=template&id=1bccb3e8"
import script from "./TableConsultPrice.vue?vue&type=script&lang=js"
export * from "./TableConsultPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports